module.exports = __webpack_public_path__ + "static/media/christmas2.82510a76.jpg";